import getUrl from 'airship/modules/get-url'
import type {GetUrlKeyValueArgs, GetUrlPositionalArgs} from 'airship/types'

import type {CurrentCompany} from './types'

export const buildGetAccessLink = (currentCompany: CurrentCompany): string => {
  const {plan_name: planName, is_ecommerce: isEcommerce} = currentCompany

  if (planName === 'orchestration' || planName === 'starter') {
    return getUrl('billing:checkout_add_addon', 'native-app-experiences')
  }

  if (!isEcommerce) {
    return 'https://www.airship.com/company/contact-us/'
  }

  return getUrl('ecomm-upgrade')
}

export const getUrlWithCreationSourceHints = (
  name: string,
  ...args: GetUrlPositionalArgs | GetUrlKeyValueArgs
): ReturnType<typeof getUrl> => {
  const url = getUrl(name, ...args)
  return `${url}?creationSource=new-push-popover`
}
